import { businessKey } from 'queryKeys';

const PLAYERS_INFORMATION = 'playersInformation';
const EVENTS = 'events';
const APPLICATIONS = 'applications';

const MUTATION_UPLOAD = 'upload';
const piQuery = businessKey.query(PLAYERS_INFORMATION);

export const results = piQuery.grid();
export const events = piQuery.exact(EVENTS);
export const applications = piQuery.exact(APPLICATIONS);

export const mutations = piQuery.mutations();

export const update = mutations.mutate(MUTATION_UPLOAD);
